module.exports = __webpack_public_path__ + "img/pazarplus-retail-card.f5715a4c.jpg";